// AddNew               ==> is a method to open a new Modal or existing Modal
// Data                 ==> is an object containing data
// DeleteLocation       ==> is a method runs on every Delete so that api can hit and fetch new data after deletetion 
// API-URL/TableName    ==> is requried to Delete Data  
import { useState } from "react";
import DeleteConfirmatiom from "../../General/DeleteConfirmation";
import NoDataFound from "../../shared/NoDataFound/NoDataFound"
const Card = (props) => {
    // console.log("DeleteProvider",props)
    const { AddNew, Data , API_URL, TableName, handleDelete, DeleteLocation,  Key, Name, dropDown, IsDeleteAllowed} = { ...props }
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [id, setID] = useState();
    // open Delete Popop
    const handleDeleteModal = (ID) => {
        setID(ID)
        setIsOpenDelete(true)
    }
    // Close Delete Popop
    const onCloseDelete = () => {setIsOpenDelete(false)}
    let DeleteConfirmation = "";
    if(isOpenDelete){
        DeleteConfirmation = <DeleteConfirmatiom  isOpenAlert={isOpenDelete} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={TableName} ID={id} onClose={handleDelete} dropDown={dropDown}/>
    }
    

  return (
    <>
    {DeleteConfirmation}
        <div className='app-padding card-view hk-card-v1 za-loc_card'>
            <div className='row row-gap-15 row-half '>
                <div className='col-md-3'   onClick={() => AddNew(null)}>
                    <div className="card app-card h-100">
                        <div className="card-body d-flex flex-column align-items-center justify-content-center">
                            <button className='btn-icon-circle'>
                                <i className="icon-Group-5719"></i>
                            </button>
                            <p className="heading lg mt-3">Add New {Name}</p>
                        </div>
                    </div>
                </div>
                {Data.length > 0 ? 
                    Data.map ((items) => {
                    return(
                    <div className='col-md-3' key={items.RecordID}>
                        <div className="card app-card">
                            <div className="card-body">
                                <div>
                                    <p className="heading ar-elispis" title={items.Name?items.Name:''}><i className="bi bi-person-fill me-1 clr-theme adasdasd"></i>{items.Name?items.Name:''}</p>
                                    <hr />
                                    <div className='d-flex gap-2 mb-3'>
                                        <p className="text font-m flex-grow-1"><i className="bi bi-telephone-fill me-1 clr-theme"></i>{items.PhoneNumber?items.PhoneNumber:''}</p>
                                        <p className="text font-m flex-grow-1 gap-1 d-flex">
                                            <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.919983 5C0.919983 4.17157 1.59156 3.5 2.41998 3.5H18.42C19.2484 3.5 19.92 4.17157 19.92 5V15.5H0.919983V5Z" fill="var(--BlueLight)" stroke="var(--primary)"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.87453 6H2.41998V9H7.87453L10.42 7.52999L7.87453 6Z" fill="var(--primary)"/>
                                                <path d="M2.41998 11H11.6508" stroke="var(--primary)" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M2.41998 12.125H8.41998" stroke="var(--primary)" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M2.41901 13.0625H6.42096" stroke="var(--primary)" stroke-width="0.5" stroke-linecap="round"/>
                                                <path d="M16.6559 13.615L17.529 12.7569L19.444 14.7052C19.681 14.9463 19.6777 15.3339 19.4366 15.5708C19.1955 15.8078 18.8079 15.8044 18.571 15.5634L16.6559 13.615Z" fill="var(--primary)"/>
                                                <circle cx="16.4509" cy="12.3342" r="1.684" transform="rotate(-85.9055 16.4509 12.3342)" fill="var(--BlueLight)" stroke="var(--primary)"/>
                                                <path d="M4.79998 8H4.45798L3.88598 7.134V8H3.54398V6.596H3.88598L4.45798 7.466V6.596H4.79998V8ZM6.11789 7.048C6.11789 7.12933 6.09922 7.204 6.06189 7.272C6.02456 7.33867 5.96722 7.39267 5.88989 7.434C5.81256 7.47533 5.71656 7.496 5.60189 7.496H5.38989V8H5.04789V6.596H5.60189C5.71389 6.596 5.80856 6.61533 5.88589 6.654C5.96322 6.69267 6.02122 6.746 6.05989 6.814C6.09856 6.882 6.11789 6.96 6.11789 7.048ZM5.57589 7.224C5.64122 7.224 5.68989 7.20867 5.72189 7.178C5.75389 7.14733 5.76989 7.104 5.76989 7.048C5.76989 6.992 5.75389 6.94867 5.72189 6.918C5.68989 6.88733 5.64122 6.872 5.57589 6.872H5.38989V7.224H5.57589ZM6.63794 6.596V8H6.29594V6.596H6.63794Z" fill="var(--BlueLight)"/>
                                            </svg>

                                           <span> {items.NPI}</span>
                                        </p>
                                    </div>
                                    {/* <p className="text font-m"><i className="bi bi-person-fill me-1 clr-theme"></i>{items.TaxonomyCode}</p> */}
                                    <p className="text mb-3 d-flex "><i className="bi bi-geo-alt-fill mt-1 me-2 clr-theme"></i>{items.Address?items.Address:items.LocationName}</p>
                                </div>
                                <div className='d-flex flex-wrap gap-2'>
                                    <button className='btn btn-orange flex-grow-1' onClick={() => AddNew(items.RecordID)}>View Details<i className='bi bi-arrow-up-right ms-2'></i></button>
                                    <button className={IsDeleteAllowed ? 'btn btn-gray  flex-grow-1' : 'btn btn-gray  flex-grow-1 diasbled'} disabled={!IsDeleteAllowed} onClick={() => handleDeleteModal(items.RecordID)}>Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}) : null
            }
            </div>
        </div>
            <NoDataFound isLoading={props.isLoading} rows={Data} />
             
    </>
  )
}

export default Card